import styled from "styled-components";

const TableRowDetailsContainer = styled.div`
  display: flex;
  padding-top: ${props => props.isVisible ? "6px" : "0px"};
  align-items: ${props => props.isVisible ? "top" : "center"};
  justify-content: space-between;
`;

export default TableRowDetailsContainer;
